const o = (t, e = 0) => (...i) => {
  typeof t == "function" && requestAnimationFrame(() => setTimeout(() => t(...i), e));
};
export {
  o as yieldCallback
};
//# sourceMappingURL=yield-callback.js.map
